import { Loader } from '@fable/components'
import { Navigate, useLocation } from 'react-router-dom'
import { getShareData, isValidType } from './helpers'
import { useQuery } from 'react-query'
import { useErrorModal } from 'hooks'
import { SharePageContent } from './SharePageContent'
import { ShareObjectType } from '@fable/types'

const SharePage = () => {
  const location = useLocation()
  const urlSegments = location.pathname.split('/')
  const type = urlSegments[1] as ShareObjectType
  const id = urlSegments[2]
  const isValid = isValidType(type)

  const { data, isLoading, error } = useQuery(
    ['share_data'],
    () => getShareData({ type, id }),
    { enabled: isValid }
  )

  useErrorModal(error)

  if (!isValid) return <Navigate to="/404" replace />

  if (isLoading) return <Loader />

  if (!data || error) return null

  const linkData = data?.data

  return <SharePageContent id={id} data={linkData} type={type} />
}

export default SharePage
